import React, { useEffect, useState } from "react";

import {
    getCampaigns,
    getCampaignStats,
} from "../services/adminApi";

import MarketingHeader from "../components/marketing/MarketingHeader";
import MarketingStats from "../components/marketing/MarketingStats";
import CampaignFilters from "../components/marketing/CampaignFilters";
import CampaignTable from "../components/marketing/CampaignTable";
import LoadingCampaigns from "../components/marketing/LoadingCampaigns";
import EmptyCampaigns from "../components/marketing/EmptyCampaigns";

import "../styles/Marketing.css";

const Marketing = () => {

    const [campaigns, setCampaigns] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadCampaigns();
    }, []);

    const loadCampaigns = async () => {

        try {

            const [
                campaignsRes,
                statsRes,
            ] = await Promise.all([
                getCampaigns(),
                getCampaignStats(),
            ]);

            setCampaigns(campaignsRes.data.campaigns || []);
            setStats(statsRes.data.stats || {});

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    if (loading) {
        return <LoadingCampaigns />;
    }

    return (

        <div className="marketing-page">

            <MarketingHeader />

            <MarketingStats stats={stats} />

            <CampaignFilters />

            {

                campaigns.length === 0 ?

                    <EmptyCampaigns />

                    :

                    <CampaignTable
                        campaigns={campaigns}
                    />

            }

        </div>

    );

};

export default Marketing;